// src/components/daily/HistoryDailyModal.jsx
import { useEffect, useState } from "react";
import BoardTable from "../../common/board/BoardTable";
import BoardPagination from "../../common/board/BoardPagination";
import SearchBar from "../../common/board/SearchFilterBar";

import { getWorkReports } from "../../../api/const";

export default function HistoryDailyModal({
  project,
  onClose,
  onSelect,
}) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  // 검색 / 필터
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("author");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  // 페이지네이션
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const params = {
        project,
        [searchField]: q,
        page,
        page_size: pageSize,
        start_date: startDate,
        end_date: endDate,
      };

      const data = await getWorkReports(params);
      setRows(data.results ?? []);
      setTotal(data.total ?? 0);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (project) fetchReports();
  }, [project, page, pageSize, searchTrigger]);

  const applySearch = () => {
    setPage(1);
    setSearchTrigger((v) => v + 1);
  };

  const columns = [
    {
      key: "date",
      header: "날짜",
      width: 160,
      render: (row) =>
        row.meta?.date
          ? new Date(row.meta.date).toLocaleDateString("ko-KR")
          : "-",
    },
    {
      key: "weather",
      header: "날씨",
      width: 200,
      render: (row) =>
        `${row.meta?.weather ?? "-"} (${row.meta?.temp_min ?? "-"} / ${
          row.meta?.temp_max ?? "-"
        })`,
    },
    {
      key: "created_by",
      header: "작성자",
      width: 120,
      render: (row) => row.created_by?.name ?? "-",
    },
  ];

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <div className="bg-white w-full max-w-5xl max-h-[85vh] rounded-lg shadow flex flex-col">

        {/* header */}
        <div className="flex justify-between items-center px-4 py-2 border-b">
          <h3 className="text-sm font-semibold">이전 공사일보 선택</h3>
          <button onClick={onClose} className="text-sm text-gray-500">
            닫기
          </button>
        </div>

        {/* search */}
        <div className="p-3 border-b">
          <SearchBar
            q={q}
            onChangeQ={setQ}
            onSearch={applySearch}
            searchField={searchField}
            onChangeSearchField={setSearchField}
            startDate={startDate}
            endDate={endDate}
            onDateChange={({ start, end }) => {
              setStartDate(start);
              setEndDate(end);
            }}
            pageSize={pageSize}
            onChangePageSize={setPageSize}
          />
        </div>

        {/* table */}
        <div className="flex-1 overflow-hidden px-3">
          <BoardTable
            columns={columns}
            rows={rows}
            loading={loading}
            keyField="dns"
            onRowClick={onSelect}
          />
        </div>

        {/* pagination */}
        <div className="border-t p-2">
          <BoardPagination
            page={page}
            pageSize={pageSize}
            total={total}
            onPageChange={setPage}
          />
        </div>
      </div>
    </div>
  );
}
